import { useEffect } from 'react'
import { useScript } from './useScript'

export const useZendesk = () => {
  const loaded = useScript(
    'https://static.zdassets.com/ekr/snippet.js?key=b0a2ea5f-87fa-4c06-a60b-1bc9f6bcb337',
    'ze-snippet'
  )

  const handlerSupport = () => {
    window.zE(() => {
      window.zE.activate()
    })
  }

  useEffect(() => {
    if (loaded) {
      window.zE('webWidget', 'hide')
      window.zE(() => {
        window.zE.hide()
      })
    }
  }, [loaded])
  return handlerSupport
}
